import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import PermitList from './PermitList';
import Permit from './Permit';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';

export default function PermitContainer({ permitSummariesData, sectionName, sectionIcon }) {
    const [selectedPermit, setSelectedPermit] = useState();

    function handleShowPermit(id) {
        let foundPermit = permitSummariesData.permits.find(x => x.id === id);
        setSelectedPermit(foundPermit);
    }

    function handlePrintPermit() {
        // const doc = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4', });
        // doc.html(document.getElementById("permitSummary"), { callback: function (doc) { doc.save('name-name.pdf'); }, margin: [35, 35, 35, 35], });

        const doc = new jsPDF();
        doc.autoTable({
            html: '#permitSummary',
            theme: 'plain',
            headStyles: { lineWidth: { bottom: .25 }, textColor: '#28445a', fontSize: 16, cellPadding: { left: 1.5, bottom: 5 } },
            bodyStyles: { lineWidth: { bottom: .25 } },
        });
        doc.save('name-name.pdf');
    }

    function handlePrintPermitList() {
        //const doc = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4', });
        //doc.html(document.getElementById("permitList"), { callback: function (doc) { doc.save('name-name.pdf'); }, margin: [35, 35, 35, 35], });

        const doc = new jsPDF({ orientation: 'p', unit: 'px', format: 'a4', });
        doc.setTextColor(40, 68, 90);
        doc.setFont(undefined, 'bold');
        doc.text(sectionName, 33, 40)
        doc.autoTable({
            html: '#permitList',
            theme: 'plain',
            startY: 50,
            headStyles: { lineWidth: { bottom: .25 }, textColor: '#28445a' },
            bodyStyles: { lineWidth: { bottom: .25 } },
        });
        doc.save('name-name.pdf');
    }

    let buttonContainer;
    let permits;
    if (permitSummariesData !== undefined) {
        permits = permitSummariesData.loading && "Loading";
        if (permitSummariesData.loading === false && permitSummariesData.permits) {
            permits = (<PermitList
                sectionName={sectionName}
                permits={permitSummariesData.permits}
                onShowPermit={handleShowPermit}
                hide={selectedPermit !== undefined}
            />);
        }
        buttonContainer = (<div className="buttonContainer flexbox-flex justify-between">
            <button onClick={handlePrintPermitList}>Print</button>
            {/*<button onClick={handleUnselectProject}>Done</button>*/}
        </div>);
    }

    let permitSummary;
    if (selectedPermit !== undefined) {

        permitSummary = (<Permit permit={selectedPermit} />);
        
        buttonContainer = (<div className="buttonContainer flexbox-flex justify-between">
            <button onClick={handlePrintPermit}>Print</button>
            <button onClick={() => setSelectedPermit()}>Done</button>
        </div>);
    }

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="permitsContainer">
            {permits}
            {permitSummary}
        </div>
        {buttonContainer}
    </>);
}